module.exports = __webpack_public_path__ + "static/media/original-charts-1-mobile.9a674526.jpg";